import request from './request';

export interface AdminSession {
  id: number;
  userId: number;
  nickname: string;
  avatarUrl: string;
  status: string;
  rounds: number;
  foodLogId?: number | null;
  createdAt: number;
}

export interface SessionMessage {
  id: number;
  sessionId: number;
  role: string;
  content: string;
  result?: LLMAnalysisResult | null;
  round: number;
  createdAt: number;
}

export interface FoodItem {
  name: string;
  estimatedGrams: number;
  calories: number;
  protein: number;
  fat: number;
  carbs: number;
  confidence: number;
}

export interface FoodResult {
  foods: FoodItem[];
  totalCalories: number;
  totalProtein: number;
  totalFat: number;
  totalCarbs: number;
  overallConfidence: number;
  mealType: string;
}

export interface UserResult {
  age?: number | null;
  heightCm?: number | null;
  weightKg?: number | null;
  gender?: string | null;
  activityLevel?: string | null;
  targetWeightKg?: number | null;
  dailyCalorieTarget?: number | null;
  proteinTarget?: number | null;
  fatTarget?: number | null;
  carbsTarget?: number | null;
  isComplete?: boolean | null;
}

export interface WeightResult {
  weightKg?: number | null;
  date?: string | null;
  note?: string;
}

export interface ExerciseResult {
  type?: string | null;
  name?: string | null;
  durationMinutes?: number | null;
  distanceKm?: number | null;
  caloriesBurned?: number | null;
  countValue?: number | null;
  countUnit?: string | null;
  intensity?: string | null;
  date?: string | null;
  note?: string;
}

export interface LLMAnalysisResult {
  intent?: string;
  foodResult?: FoodResult | null;
  userResult?: UserResult | null;
  weightResult?: WeightResult | null;
  exerciseResult?: ExerciseResult | null;
  aiMessage?: string;
  isPartial: boolean;
}

export interface PaginatedResponse<T> {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  items: T[];
}

export function getAdminSessions(params: {
  userId?: string;
  startTime?: string;
  endTime?: string;
  page?: number;
  pageSize?: number;
}): Promise<PaginatedResponse<AdminSession>> {
  return request.get('/api/admin/v1/sessions', { params });
}

export interface SessionMessagesResponse {
  messages: SessionMessage[];
  result: LLMAnalysisResult | null;
  sessionType: string;
  foodLogId: number | null;
  status: string;
}

export function getSessionMessages(sessionId: number): Promise<SessionMessagesResponse> {
  return request.get(`/api/admin/v1/sessions/${sessionId}/messages`);
}
